<template>
  <div v-if="value" class="flex gap-2 items-center">
    <a
      class="group flex items-center gap-1.5 text-primary hover:underline"
      :href="`/uploads/${value.url}`"
      target="_blank"
    >
      <Icon class="text-xl" name="picture_as_pdf" is-filled />
      <span class="text-sm font-medium">{{ value.name }}</span>
    </a>

    <Button variant="icon" @click="handleDelete">
      <Icon class="text-xl" name="delete" />
    </Button>
  </div>
  <div v-else>
    <label
      class="flex flex-col items-center justify-center gap-2 h-40 w-full mx-auto cursor-pointer rounded border border-dashed border-red-500 p-4 transition-colors text-center"
      :class="{ 'bg-primary/10': isDragging }"
      for="upload-cv"
      @drop.prevent="handleDrop"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
    >
      <Icon class="text-3xl text-primary" name="backup" is-filled />
      <span class="text-lg font-medium text-primary">Upload your CV</span>
      <span class="text-xs text-zinc-600">Upload or drag and drop here</span>
      <span class="text-xs text-zinc-600">Max 1 upload/day - PDF, DOC, DOCX (5MB)</span>
    </label>

    <input
      id="upload-cv"
      class="hidden"
      type="file"
      accept=".pdf,.doc,.docx"
      @change="handleFileInput"
    />

    <div v-if="errors.length" class="mt-2 text-center text-xs text-red-500">
      <span v-for="(error, index) in errors" :key="index">{{ error }}</span>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';

  const props = defineProps({
    value: { type: Object, default: null },
    errors: { type: Array, default: () => [] }
  });

  const emits = defineEmits(['update:value', 'update:errors']);
  const isDragging = ref(false);

  function handleFileInput(event) {
    const file = event.target.files[0];
    emits('update:value', file);
    emits('update:errors', []);
    event.target.value = '';
  }

  function handleDrop(event) {
    isDragging.value = false;
    const file = event.dataTransfer.files[0];
    emits('update:value', file);
    emits('update:errors', []);
  }

  function handleDelete() {
    emits('update:value', null);
    emits('update:errors', []);
  }
</script>
